import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ApiOrganization {
  id: string;
  name: string;
  surveys: ApiSurvey[];
  segments: string[];
}

export interface ApiSurvey {
  id: string;
  name: string;
  lastUpdatedOn: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiOrganizationService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/organizations';

  constructor(private http: HttpClient) {}

  getOrganizations(): Observable<ApiOrganization[]> {
    return this.http.get<unknown>(`${this.apiBaseUrl}${this.apiPath}`).pipe(
      map(response => this.mapOrganizations(response))
    );
  }

  private mapOrganizations(response: unknown): ApiOrganization[] {
    if (!Array.isArray(response)) {
      return [];
    }

    return response.map(item => ({
      id: this.safeString(item, 'id'),
      name: this.safeString(item, 'name'),
      surveys: this.mapSurveys(this.safeArray(item, 'surveys')),
      segments: this.safeArray(item, 'segments').filter((s): s is string => typeof s === 'string')
    }));
  }

  private mapSurveys(response: unknown[]): ApiSurvey[] {
    return response.map(item => ({
      id: this.safeString(item, 'id'),
      name: this.safeString(item, 'name'),
      lastUpdatedOn: this.safeString(item, 'lastUpdatedOn')
    }));
  }

  private safeString(obj: unknown, key: string): string {
    if (!obj || typeof obj !== 'object') {
      return '';
    }

    const value = (obj as Record<string, unknown>)[key];
    return typeof value === 'string' ? value : '';
  }

  private safeArray(obj: unknown, key: string): unknown[] {
    if (!obj || typeof obj !== 'object') {
      return [];
    }

    const value = (obj as Record<string, unknown>)[key];
    return Array.isArray(value) ? value : [];
  }
}